import DAMAGE_LOOKUP from '../../../../config/simm/default/damage_lookup.yml';
import dig from '../dig';

export function lookupOverallDamageRating(structureType, ratio) {
  const ratingTable = dig(DAMAGE_LOOKUP, 'overall', structureType);
  const ratings = Object.keys(ratingTable).map((rating) => Number.parseInt(rating));
  const maxRating = Math.max(...ratings);
  const minRating = Math.min(...ratings);

  if (ratio > ratingTable[maxRating]) {
    return maxRating;
  }

  if (ratio === ratingTable[minRating]) {
    return minRating;
  }

  return findRatingForRatio(ratings, ratio, ratingTable);
}

export function lookupLocalDamageRating(deviation, deviationUnit, thickness, thicknessUnit) {
  const ratingTable = dig(DAMAGE_LOOKUP, 'local', 'ratio');
  const minDeviation = dig(DAMAGE_LOOKUP, 'local', 'min_deviation');
  const ratings = Object.keys(ratingTable).map((rating) => Number.parseInt(rating));
  const maxRating = Math.max(...ratings);
  const minRating = Math.min(...ratings);

  deviation = deviationUnit === 'cm' ? deviation * 10 : deviation;
  thickness = thicknessUnit === 'cm' ? thickness * 10 : thickness;

  const ratio = deviation / thickness * 100.0;

  // Ignore thickness for any deviation smaller than 1mm
  if (deviation < minDeviation) return 1;

  if (ratio > ratingTable[maxRating]) {
    return maxRating;
  }

  if (ratio === ratingTable[minRating]) {
    return minRating;
  }

  return findRatingForRatio(ratings, ratio, ratingTable);
}

function findRatingForRatio(ratings, ratio, ratingTable) {
  return ratings.find((rating) => {
    if (ratio > ratingTable[rating] && ratio <= ratingTable[rating + 1]) {
      return rating;
    }
  });
}
